
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableHeader, 
  TableRow 
} from '@/components/ui/table';
import { Users as UsersIcon } from 'lucide-react';
import { UserTableRow } from './UserTableRow';
import { User } from '@/types/user';

interface UsersTableProps {
  users: User[];
  onUserUpdated: () => void;
}

export function UsersTable({ users, onUserUpdated }: UsersTableProps) {
  if (users.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-10">
        <UsersIcon className="h-12 w-12 text-muted-foreground mb-2" />
        <h3 className="text-lg font-medium">No users found</h3>
        <p className="text-center text-muted-foreground mt-1">
          Invite your first user to get started.
        </p>
      </div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>User</TableHead>
          <TableHead>Organization</TableHead>
          <TableHead>Role</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Invited</TableHead>
          <TableHead className="w-[80px]"></TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {users.map((user) => (
          <UserTableRow key={user.id} user={user} onUserUpdated={onUserUpdated} />
        ))}
      </TableBody>
    </Table>
  );
}
